import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

interface NCEResponse {
  idDE: string;
  kuDEBase64: string;
  cdc: string;
  docNumDE: string;
}

interface CancelPagoFEResponse {
  success: boolean;
  message: string;
  data: {
    pagoId: string;
    ventaId: string;
    mensaje: string;
    detalles: {
      ventaAnulada: boolean;
      movimientoCajaRevertido: boolean;
      feAnulada: boolean;
    };
    nce: NCEResponse | null;
  };
}

export async function cancelPagoFE(ventaId: string): Promise<CancelPagoFEResponse> {
  await sleep(1000);
  const response = await api.put<CancelPagoFEResponse>(`caja_actual/anular-pago-fe/${ventaId}`);
  return response.data;
}

export function useCancelPagoFEMutation(ventaId: string, mutationConfig: MutationConfig<CancelPagoFEResponse> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: async () => await cancelPagoFE(ventaId),
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["ventas"] });
      queryClient.invalidateQueries({ queryKey: ["caja_actual"] });
    },
  })
}

export interface CancelPagoFEMutationProps {
  ventaId: string,
  mutationConfig?: MutationConfig<CancelPagoFEResponse>,
  children?: (mutationResult: MutationResult<CancelPagoFEResponse>) => ReactNode
}

export function CancelPagoFEMutation({
  ventaId,
  children,
  mutationConfig
}: CancelPagoFEMutationProps) {
  const mutationResult = useCancelPagoFEMutation(ventaId, mutationConfig);
  return children && children(mutationResult)
}
